import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useParams,
} from "react-router-dom";

import Home from "./pages/Home";
import Aitools from "./pages/Aitools";
import Blog from "./pages/Blog";

import { HelmetProvider } from "react-helmet-async";

import Article from "./Blogs/Article";
import AitoolsComponent from "./pages/Aitools";

import Learning from "./pages/Learning";

import ContactHu from "./pages/ContactHu";
import ContactEn from "./pages/ContactEn";
import ContactDe from "./pages/ContactDe";
import ContactEs from "./pages/ContactEs";
import ContactFr from "./pages/ContactFr";
import WriteArticle from "./pages/WriteArticle";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PageNotFound from "./components/PageNotFound";
import NotFound from "./components/404"; // Importáld az új komponenst
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import NewsArchive from "./components/NewsArchive";
import CookiePolicy from "./components/CookiePolicy";
import Imprint from "./components/Imprint";
import TranslatedHeader from "./components/Header"; // Import the TranslatedHeader
import Footer from "./components/Footer"; // Assuming you have a footer

import "bootstrap/dist/js/bootstrap.bundle.min"; // Bootstrap import
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <TranslatedHeader />
          <Routes>
            <Route path="/" element={<Navigate to="/en/Home" replace={true} />} />
            <Route path="/:lng/Home" element={<Home />} />
            <Route path="/:lng/Blog" element={<Blog />} />
            <Route path="/:lng/Aitools" element={<Aitools />} />
            <Route path="/:lng/Learning" element={<Learning />} />
            <Route path="/:lng/Contact" element={<Contact />} />
            <Route path="/login" element={<LoginPage />} />

            <Route path="/article/:artID" element={<Article />} />

            <Route path="*" element={<NotFound />} />
            <Route path="/TermsOfUse" element={<TermsOfUse />} />
            <Route path="/NewsArchive" element={<NewsArchive />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/CookiePolicy" element={<CookiePolicy />} />
            <Route path="/Imprint" element={<Imprint />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <WriteArticle />
                </ProtectedRoute>
              }
            />
          </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

// Contact dinamikus komponens
function Contact() {
  const { lng } = useParams();
  switch (lng) {
    case "hu":
      return <ContactHu />;
    case "en":
      return <ContactEn />;
    case "de":
      return <ContactDe />;
    case "es":
      return <ContactEs />;
    case "fr":
      return <ContactFr />;
    default:
      return <Navigate to="/en/Contact" replace={true} />;
  }
}

export default App;
